/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandValorant = createReactComponent("brand-valorant", "IconBrandValorant", [
  ["path", { d: "M14.5 14h4.5l2 -2v-6z", key: "svg-0" }],
  ["path", { d: "M9 19h5l-11 -13v6z", key: "svg-1" }]
]);

export { IconBrandValorant as default };
//# sourceMappingURL=IconBrandValorant.js.map
